import React from "react";
import { useColumnResizeContext } from "../../context/ColumnResizeContext";

/**
 * Renderiza um <colgroup> com <col> por coluna registrada no Provider.
 *
 * Browsers diferem na fidelidade entre `<col width>` e `<th style.width>`.
 * Aplicar em ambos (Colgroup AQUI + ResizableTh tambem) garante que o
 * navegador respeite a largura mesmo em modo `table-layout: fixed`.
 */
export default function ResizableColgroup() {
  const ctx = useColumnResizeContext();
  if (!ctx || !ctx.columns?.length) return null;
  return (
    <colgroup>
      {ctx.columns.map((col) => {
        const width = ctx.widths[col.key];
        return (
          <col
            key={col.key}
            style={width ? { width } : undefined}
          />
        );
      })}
    </colgroup>
  );
}
